<template>
  <div ref="subGlobal" class="global-main global-shadow">
    <div class='global-panel' v-loading.body="loading.main" style="padding: 10px">
    <div class="global-header">
      <el-page-header @back="goBack" :content=courseName></el-page-header>
    </div>
    <el-row>
      <el-col :span="16">
        <el-card shadow="hover" style="margin: 10px;flex: 1">
          <div style="clear: both">
            <div class="global-header">
              <div class="global-title">课程信息</div>
              <div class='global-tbar'>
                <el-button size="small" type="danger" @click="addCourse()">新增</el-button>
                <el-button size="small" type="warning" @click="noChooseStudent()">未选课学生</el-button>
                <el-button size="small" type="success" @click="exportChooseList()">导出课程列表</el-button>
                <el-button size="small" type="success" @click="exportChooseResult()">导出选课明细</el-button>
              </div>
            </div>
            <el-table :data="courseList" border stripe style="width: 100%" size="mini" @current-change="handleCourseChange" highlight-current-row >
              <el-table-column prop="courseName" label="课程名称" sortable min-width="200" ></el-table-column>
              <el-table-column prop="courseTime" label="上课时间" width="100" sortable></el-table-column>
              <el-table-column prop="place" label="上课地点" width="150" sortable show-overflow-tooltip></el-table-column>
              <el-table-column prop="teacherName" label="教师" width="100" sortable show-overflow-tooltip></el-table-column>
              <el-table-column prop="upperType" label="上限类型" width="100" sortable></el-table-column>
              <el-table-column label="人数上限" width="100" sortable>
                <template slot-scope="scope">
                  {{scope.row.personNum}}/<span style="color:red">{{scope.row.upperLimit}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="allScope" label="全部可选" width="120" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.allScope" type="success">全部可选</el-tag>
                  <el-tag v-if="!scope.row.allScope" type="danger">部分可选</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center" fixed="right" >
                <template slot-scope="scope">
                  <el-button class="global-text-btn-success" size="mini" type="text" @click="showCourse(scope.row)" style="margin-left: 10px;">编辑</el-button>
                  <el-button class="global-text-btn-danger" size="mini" type="text" @click="dropCourse(scope.row)" style="margin-left: 10px;">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <div style="flex: 1">
          <el-card shadow="hover" style="margin: 10px;">
            <div class="global-header">
              <div class="global-title">任课教师</div>
              <div class='global-tbar'>
                <el-tooltip class="box-item" effect="dark" content="刷新" placement="top-start">
                  <el-button size="small" type="primary" icon="el-icon-refresh" @click="handleCourseChange(currentCourse)"></el-button>
                </el-tooltip>
                <el-button size="small" type="primary"  @click="selectStaff()">选择教职工</el-button>
              </div>
            </div>
            <el-table :data="staffList" style="width: 100%" row-key="id" max-height="450" border stripe size="mini" >
              <el-table-column label="工号" prop="seriaNo" width="100" ></el-table-column>
              <el-table-column label="姓名" prop="staffName" width="100" ></el-table-column>
              <el-table-column label="操作" prop="desc" fixed="right" min-width="50">
                <template slot-scope="scope">
                  <el-button @click="deleteStaff(scope.row)" type="text" style="color: #F56C6C" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
          <el-card shadow="hover" style="margin: 10px;">
            <div class="global-header">
              <div class="global-title">可选范围</div>
              <div class='global-tbar'>
                <el-button size="small" type="primary"  @click="selectClazz()">选择班级</el-button>
              </div>
            </div>
            <el-table :data="clazzList" style="width: 100%" row-key="id" max-height="450" border stripe size="mini" >
              <el-table-column label="校区" prop="schoolArea" width="100" ></el-table-column>
              <el-table-column label="班级名称" prop="clazzName" min-width="100" ></el-table-column>
              <el-table-column label="操作" prop="desc" fixed="right" width="50">
                <template slot-scope="scope">
                  <el-button @click="deleteClazz(scope.row)" type="text" style="color: #F56C6C" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
          <el-card shadow="hover" style="margin: 10px">
            <div class="global-header">
              <div class="global-title">已选人员</div>
              <div class='global-tbar'>
                <el-tooltip class="box-item" effect="dark" content="下载模板" placement="top-start">
                  <el-button size="small" type="success" icon="el-icon-download" @click="downloadChooseFile()"></el-button>
                </el-tooltip>

                <el-upload class="upload-demo"
                           :action="'rest/course/uploadChooseCourseFile' "
                           :on-progress="uploadProgress"
                           :on-error="uploadError" :on-success="uploadSuccess" :on-preview="handlePreview"
                           :on-remove="handleRemove" :file-list="fileList" :show-file-list='false'
                           list-type="picture">
                  <el-button type="primary" size="small" icon="el-icon-upload2">上传强制选课</el-button>
                </el-upload>
              </div>
            </div>
            <el-table :data="studentList" style="width: 100%" row-key="id" max-height="450" border stripe size="mini" >
              <el-table-column label="校区" prop="schoolArea" width="100" ></el-table-column>
              <el-table-column label="班级" prop="clazzName" width="100" ></el-table-column>
              <el-table-column label="姓名" prop="studentName" width="100" ></el-table-column>
              <el-table-column label="操作" fixed="right" min-width="50">
                <template slot-scope="scope">
                  <el-button @click="deleteChooseCourse(scope.row)" type="text" style="color: #F56C6C" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="visible.param" width="50%" v-loading="loading.param" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="serverForm"  :model="currentRecord" label-width="80px":rules="serverRules">
        <el-form-item label="课程名称" prop="courseName">
          <el-input v-model="currentRecord.courseName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="课程介绍" prop="courseDesc">
          <el-input v-model="currentRecord.courseDesc" size="small" type="textarea"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="上课时间" prop="courseTime">
              <el-input v-model="currentRecord.courseTime"  size="small" placeholder="例如：周三"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上课地点" prop="place">
              <el-input v-model="currentRecord.place" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="上限类型" prop="upperType">
              <el-select v-model="currentRecord.upperType" placeholder="请选择" size="small">
                <el-option v-for="item in upperTypeCombo" :key="item.key" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人数上限" prop="upperLimit">
              <el-input v-model="currentRecord.upperLimit" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学时" prop="clazzHour">
              <el-input v-model="currentRecord.clazzHour" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学分" prop="credit">
              <el-input v-model="currentRecord.credit" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始节次" prop="startSection">
              <el-input v-model="currentRecord.startSection" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="终止节次" prop="endSection">
              <el-input v-model="currentRecord.endSection" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="全部可选" prop="allScope">
          <el-switch v-model="currentRecord.allScope"  size="small"/>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="currentRecord.note" size="small" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible.param = false">取 消</el-button>
        <el-button type="primary" @click="saveCourse()">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="班级选择" :visible.sync="visible.selectClazz" v-loading="loading.selectClazz" width="40%" :close-on-click-modal="false">
      <el-card shadow="hover" style="margin: 10px;">
        <div>
          <el-form :inline="true" :model="clazzCondition" class="demo-form-inline" size="mini">
            <el-form-item label="校区">
              <el-input v-model="clazzCondition.schoolArea" placeholder="校区"></el-input>
            </el-form-item>
            <el-form-item label="年级">
              <el-input v-model="clazzCondition.grade" placeholder="年级"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="findClazzByCondition">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table :data="allClazzList" style="width: 100%" row-key="id" max-height="450" border stripe size="mini" @selection-change="handleSelectionClazz">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="校区" prop="schoolArea"></el-table-column>
          <el-table-column label="年级" prop="grade"></el-table-column>
          <el-table-column label="班级名称"prop="clazzName"></el-table-column>
        </el-table>
      </el-card>
      <div style="clear: both;"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible.selectClazz = false" size="small">取 消</el-button>
        <el-button type="primary" @click="selectedClazz" size="small">选 中</el-button>
       </span>
    </el-dialog>
    <el-dialog title="教师选择" :visible.sync="visible.selectStaff" v-loading="loading.selectStaff" width="40%" :close-on-click-modal="false">
      <el-card shadow="hover" style="margin: 10px;">
        <div>
          <el-form :inline="true" :model="staffCondition" class="demo-form-inline" size="mini">
            <el-form-item label="工号">
              <el-input v-model="staffCondition.seriaNo" placeholder="工号"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="staffCondition.staffName" placeholder="姓名"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="findStaffByCondition">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table :data="allStaffList" style="width: 100%" row-key="id" max-height="450" border stripe size="mini" @selection-change="handleSelectionStaff">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="工号" prop="seriaNo"></el-table-column>
          <el-table-column label="教师" prop="staffName"></el-table-column>
        </el-table>
      </el-card>
      <div style="clear: both;"></div>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.selectStaff = false" size="small">取 消</el-button>
      <el-button type="primary" @click="selectedStaff" size="small">选 中</el-button>
     </span>
    </el-dialog>

    <el-dialog title="未选课学生" :visible.sync="visible.noChooseStudent" v-loading="loading.noChooseStudent"  width="60%" :close-on-click-modal="false">
      <el-card shadow="hover" style="margin: 10px;">
        <div>
          <el-form :inline="true" :model="noChooseCondition" class="demo-form-inline" size="mini">
            <el-form-item label="校区">
              <el-input v-model="noChooseCondition.schoolArea" placeholder="校区"></el-input>
            </el-form-item>
            <el-form-item label="年级">
              <el-input v-model="noChooseCondition.grade" placeholder="年级"></el-input>
            </el-form-item>
            <el-form-item label="班级">
              <el-input v-model="noChooseCondition.clazzName" placeholder="班级"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="findNoChooseStudentByCondition">查询</el-button>
              <el-button type="success" @click="downloadNoChooseStudent">导出</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table :data="noChooseStudentList" style="width: 100%" row-key="id" max-height="450" border stripe size="mini">
          <el-table-column label="校区" prop="schoolArea" width="100" ></el-table-column>
          <el-table-column label="班级" prop="clazzName" width="100" ></el-table-column>
          <el-table-column label="学号" prop="seriaNo" width="200" ></el-table-column>
          <el-table-column label="姓名" prop="studentName" min-width="100" ></el-table-column>
        </el-table>
      </el-card>
      <div style="clear: both;"></div>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.noChooseStudent = false" size="small">关 闭</el-button>
     </span>
    </el-dialog>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CourseTask',
  data() {
    return {
      courseName: '课程设定',
      taskId :null,
      upperTypeCombo :[],
      // 遮罩
      loading: {main: false, param: false, selectClazz: false, selectStaff: false, noChooseStudent: false},
      // 可见
      visible: {param: false, selectClazz: false, selectStaff: false, noChooseStudent: false},
      courseList:[],
      fileList: [],
      // 当前记录
      currentRecord: {},
      currentCourse: {},
      // 校验规则
      serverRules: {
        courseName: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        courseTime: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        place: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        teacherNo: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        upperType: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        upperLimit: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        startSection: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        endSection: [
          { required: true, message: '该项必填', trigger: 'change' }
        ]
      },
      clazzList: [],
      staffList: [],
      studentList: [],
      allClazzList: [],
      allStaffList: [],
      noChooseStudentList:[],
      clazzCondition: {schoolArea: '', grade: ''},
      staffCondition: {seriaNo: '', staffName: ''},
      noChooseCondition: {schoolArea: '', grade: '', clazzName: ''},
      selectionClazz:[],
      selectionStaff:[]
    }
  },

  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight - vm.$baize.frameTitleHeight) + 'px';
    vm.taskId = vm.$route.query.id;
    vm.courseName = vm.$route.query.taskName+" | 课程设定";
    vm.findByCourse();
    vm.findEnumCombo();
  },

  methods: {
    /**
     * 返回课程任务页面
     */
    goBack: function () {
      var vm = this;
      // 作为正常页面打开
      vm.$router.push({path: '/CourseTask'});
    },
    findEnumCombo: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.main = true;
      var params = {className:"com.megrezsoft.app.business.common.enumitem.UpperType",blank:false};
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: params}).then(response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 更新数据
        vm.upperTypeCombo = response.body;
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    findByCourse: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.main = true;
      // 请求后台
      vm.$http.get('rest/course/findByCourse', {params: {taskId:vm.taskId}}).then(response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 更新数据
        vm.courseList = response.body.courseList;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    addCourse: function () {
      var vm = this;
      vm.currentRecord = {id:null,taskId:vm.taskId,courseName:null,courseDesc:null,courseTime:null,clazzHour:null,credit:null,place:null,teacherName:null,startSection:null,endSection:null,upperType:null,upperLimit:null,allScope:true};
      vm.visible.param = true;
    },
    showCourse: function (record) {
      var vm = this;
      vm.currentRecord = JSON.parse(JSON.stringify(record));
      vm.visible.param = true;
    },
    dropCourse: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】课程[' + record.courseName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.post('rest/course/dropCourse', null, {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCourse();
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    saveCourse: function () {
      var vm = this;
      // 校验
      vm.$refs['serverForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['serverForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.param = true;
        // 请求后台
        vm.$http.post('rest/course/saveCourse', vm.currentRecord).then(function (response) {
          // 关闭遮罩
          vm.loading.param = false;
          // 关闭窗口
          vm.visible.param = false;
          // 刷新
          vm.findByCourse();
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.param = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      });
    },
    selectClazz : function () {
      var vm = this;
      if(!vm.currentCourse.id){
        vm.$alert('请先选择课程', '提示',{type:'error'});
        return;
      }
      vm.visible.selectClazz = true;
      vm.findClazzByCondition();
    },
    deleteClazz: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】班级[' + record.clazzName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.post('rest/course/deleteScope?scopeId='+record.id).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.handleCourseChange(vm.currentCourse);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    selectStaff : function () {
      var vm = this;
      if(!vm.currentCourse.id){
        vm.$alert('请先选择课程', '提示',{type:'error'});
        return;
      }
      vm.visible.selectStaff = true;
      vm.findStaffByCondition();
    },
    deleteStaff: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】教师[' + record.staffName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.post('rest/course/deleteStaff?csId='+record.id).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.handleCourseChange(vm.currentCourse);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    deleteChooseCourse: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】[' + record.studentName + ']的选课记录吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.post('rest/course/deleteChooseCourse?accId='+record.id).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.handleCourseChange(vm.currentCourse);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    /**
     * 选中课程
     */
    handleCourseChange : function (course) {
      var vm = this;
      vm.currentCourse = course;
      vm.staffList = [];
      vm.clazzList = [];
      vm.studentList = [];
      if(course) {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.get('rest/course/findCourseClazz',{params: {courseId:course.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 刷新
          vm.staffList = response.body.staffList;
          vm.clazzList = response.body.clazzList;
          vm.studentList = response.body.studentList;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },
    /**
     * 选中班级
     */
    selectedClazz: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.selectClazz = true;
      if(!vm.currentCourse){
        vm.$alert('请先选择课程', '提示',{type:'error'});
        return;
      }
      // 请求后台
      vm.$http.post('rest/course/selectedClazz?courseId='+vm.currentCourse.id, vm.selectionClazz).then(function (response) {
        // 关闭遮罩
        vm.loading.selectClazz = false;
        vm.visible.selectClazz = false;
        vm.handleCourseChange(vm.currentCourse);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.selectClazz = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    /**
     * 选中教职工
     */
    selectedStaff: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.selectStaff = true;
      if(!vm.currentCourse){
        vm.$alert('请先选择课程', '提示',{type:'error'});
        return;
      }
      // 请求后台
      vm.$http.post('rest/course/selectedStaff?courseId='+vm.currentCourse.id, vm.selectionStaff).then(function (response) {
        // 关闭遮罩
        vm.loading.selectStaff = false;
        vm.visible.selectStaff = false;
        vm.handleCourseChange(vm.currentCourse);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.selectStaff = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    /**
     * 根据条件查询班级
     */
    findClazzByCondition: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.selectClazz = true;
      // 请求后台
      vm.$http.get('rest/course/findClazzByCondition?schoolArea=' + vm.clazzCondition.schoolArea + "&grade=" + vm.clazzCondition.grade).then(function (response) {
        // 关闭遮罩
        vm.loading.selectClazz = false;
        // 刷新
        vm.allClazzList = JSON.parse(response.bodyText) ;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.selectClazz = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    /**
     * 根据条件查询教师
     */
    findStaffByCondition: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.selectStaff = true;
      // 请求后台
      vm.$http.get('rest/course/findStaffByCondition?seriaNo=' + vm.staffCondition.seriaNo + "&staffName=" + vm.staffCondition.staffName).then(function (response) {
        // 关闭遮罩
        vm.loading.selectStaff = false;
        // 刷新
        vm.allStaffList = JSON.parse(response.bodyText) ;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.selectStaff = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    /**
     * 选中的数据
     */
    handleSelectionClazz:function (val){
      this.selectionClazz = val;
    },
    handleSelectionStaff:function (val){
      this.selectionStaff = val;
    },
    noChooseStudent : function () {
      var vm = this;
      vm.visible.noChooseStudent = true;
      vm.findNoChooseStudentByCondition();
    },
    exportChooseList: function () {
      var vm = this;
      vm.loading.main = true;
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'rest/course/exportChooseList?taskId='+vm.taskId, true);
      xhr.responseType = 'arraybuffer';
      xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
      xhr.onreadystatechange = function (event) {
        vm.loading.main = false;
        if (this.readyState == 4 && this.status == 200) {
          var contentDisposition = xhr.getResponseHeader('Content-Disposition');
          var index = contentDisposition.indexOf("attachment; filename=");
          var fileName = "未知文件"
          if (index >= 0) {
            fileName = contentDisposition.substring(index + 21);
          }
          //生成Blob对象，通过创建的a标签点击下载
          var objectUrl = URL.createObjectURL(new Blob([this.response]));
          var link = document.createElement("a");
          link.download = decodeURIComponent(fileName);
          link.href = objectUrl;
          link.click();
        } else if (this.readyState == 4 && this.status != 200) {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        }
      };
      xhr.send();
    },
    exportChooseResult: function () {
      var vm = this;
      vm.loading.main = true;
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'rest/course/exportChooseResult?taskId='+vm.taskId, true);
      xhr.responseType = 'arraybuffer';
      xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
      xhr.onreadystatechange = function (event) {
        vm.loading.main = false;
        if (this.readyState == 4 && this.status == 200) {
          var contentDisposition = xhr.getResponseHeader('Content-Disposition');
          var index = contentDisposition.indexOf("attachment; filename=");
          var fileName = "未知文件"
          if (index >= 0) {
            fileName = contentDisposition.substring(index + 21);
          }
          //生成Blob对象，通过创建的a标签点击下载
          var objectUrl = URL.createObjectURL(new Blob([this.response]));
          var link = document.createElement("a");
          link.download = decodeURIComponent(fileName);
          link.href = objectUrl;
          link.click();
        } else if (this.readyState == 4 && this.status != 200) {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        }
      };
      xhr.send();
    },
    findNoChooseStudentByCondition: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.noChooseStudent = true;
      vm.noChooseCondition.taskId = vm.taskId;
      // 请求后台
      vm.$http.get('rest/course/findNoChooseStudentByCondition',{params: vm.noChooseCondition}).then(function (response) {
        // 关闭遮罩
        vm.loading.noChooseStudent = false;
        // 刷新
        vm.noChooseStudentList = JSON.parse(response.bodyText) ;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.noChooseStudent = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    downloadNoChooseStudent: function () {
      var vm = this;
      vm.loading.noChooseStudent = true;
      vm.noChooseCondition.taskId = vm.taskId;
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'rest/course/downloadNoChooseStudentByCondition', true);
      xhr.responseType = 'arraybuffer';
      xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
      xhr.onreadystatechange = function (event) {
        vm.loading.noChooseStudent = false;
        if (this.readyState == 4 && this.status == 200) {
          var contentDisposition = xhr.getResponseHeader('Content-Disposition');
          var index = contentDisposition.indexOf("attachment; filename=");
          var fileName = "未知文件"
          if (index >= 0) {
            fileName = contentDisposition.substring(index + 21);
          }
          //生成Blob对象，通过创建的a标签点击下载
          var objectUrl = URL.createObjectURL(new Blob([this.response]));
          var link = document.createElement("a");
          link.download = decodeURIComponent(fileName);
          link.href = objectUrl;
          link.click();
        } else if (this.readyState == 4 && this.status != 200) {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        }
      };
      xhr.send(JSON.stringify(vm.noChooseCondition));
    },
    // 下载附件
    downloadChooseFile: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.main = true;
      let xhr = new XMLHttpRequest();
      xhr.open('POST', '/rest/course/downloadChooseFile', true);
      xhr.responseType = 'arraybuffer';
      xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
      xhr.onreadystatechange = function (event) {
        if (this.readyState == 4 && this.status == 200) {
          // 关闭遮罩
          vm.loading.main = false;
          let contentDisposition = xhr.getResponseHeader('Content-Disposition');
          let index = contentDisposition.indexOf("attachment; filename=");
          let fileName = "未知文件"
          if (index >= 0) {
            fileName = contentDisposition.substring(index + 21);
          }
          //生成Blob对象，通过创建的a标签点击下载
          var objectUrl = URL.createObjectURL(new Blob([this.response]));
          var link = document.createElement("a");
          link.download = decodeURIComponent(fileName);
          link.href = objectUrl;
          link.click();
        } else if (this.readyState == 4 && this.status != 200) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '下载失败'});
          vm.$baize.handle(vm, {status: this.status, body: this.response});
        }
      };
      xhr.send();
    },
    uploadProgress:function (event, file, fileList){
      var vm =this
      vm.loading.main = true;
    },
    uploadError:function (err, file, fileList){
      var vm =this
      vm.loading.main = false;
      // 弹出错误信息
      this.$alert(JSON.parse(err.message).message, '警告', {
        confirmButtonText: '确定',
        type: 'error'
      });
    },
    uploadSuccess:function (){
      var vm =this
      vm.loading.main = false;
      vm.$notify({position: 'bottom-right', type: 'success', message: '上传成功'});
    },
    handlePreview:function (){

    },
    handleRemove:function (){
    },
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/app/Course.vue